import React, { Fragment } from "react";
import { Table, Modal, Accordion, Card, Row, Col } from "react-bootstrap";
import PersonView from "./PersonView";
import TermRendererLine from "./renderers/TermRendererLine";
import ModalPersonRenderer from "./renderers/ModalPersonRenderer";
import PreviousAdvisorsView from "./PreviousAdvisorsView";

interface CurrentAdvisorsViewState
{
    modalData: Person;
    showModal: boolean;
    open: boolean;
}

interface CurrentAdvisorsViewProps
{
    data: Advisors;
}

export default class AdvisorsView extends React.Component<CurrentAdvisorsViewProps, CurrentAdvisorsViewState>
{
    constructor(props: CurrentAdvisorsViewProps)
    {
        super(props);

        this.state = {
            modalData: null,
            showModal: false,
            open: true
        };
    }

    render(): React.ReactNode
    {
        const handleClose = () => this.setState({ showModal: false });
        const handleShow = (itm: any): void =>
        {
            this.setState({ showModal: true, modalData: itm });
        };

        return <Fragment>
            <Accordion defaultActiveKey={"0"}>
                <Card>
                    <Accordion.Toggle href={"javascript:void(0)"} as={"a"} aria-expanded={this.state.open} variant="link" eventKey="0" onClick={() => this.setState({ open: !this.state.open })}>
                        <Card.Header>
                            <Row>
                                <Col xs={10}>
                                    <h2>Current</h2>
                                </Col>
                                <Col xs={1} className="text-right chevron">
                                    <h2><i className={this.state.open ? "far fa-chevron-up" : "far fa-chevron-down"}></i></h2>
                                </Col>
                            </Row>
                        </Card.Header>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            {
                                <Table responsive className="list">
                                    <thead>
                                        <tr>
                                            <th>NAME</th>
                                            <th><i className="fas fa-envelope"></i></th>
                                            <th>DEPARTMENT</th>
                                            <th>TYPE</th>
                                            <th>TERMS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            (this.props.data.advisors && this.props.data.advisors.length > 0)
                                                ?
                                                this.props.data.advisors.map((itm: Advisor, i) =>
                                                {
                                                    return <tr key={i}>
                                                        <td style={{ width: "250px" }}><a style={{ color: "#1C4B87" }} onClick={(): void => handleShow(itm)}><PersonView data={itm} /></a></td>
                                                        <td className="td-normal"><a href={`mailto:${itm.email}`}><i className="fas fa-envelope"></i></a></td>
                                                        <td className="td-normal">{itm.department ? itm.department : " - "}</td>
                                                        <td className="td-normal">{itm.advisorType}</td>
                                                        <td style={{ maxWidth: "200px" }} className="td-normal"><TermRendererLine value={itm.terms} /></td>
                                                    </tr>;

                                                })
                                                :
                                                <tr className={"text-center"}>
                                                    <td colSpan={5}>
                                                        <p className="error-text">No Advisors data available</p>
                                                    </td>
                                                </tr>
                                        }
                                    </tbody>
                                </Table>
                            }
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
            <Modal size={"sm"} centered show={this.state.showModal} onHide={handleClose}>
                <Modal.Body>
                    <ModalPersonRenderer data={this.state.modalData} />
                </Modal.Body>
            </Modal>
            <PreviousAdvisorsView />
        </Fragment>;
    }
}